module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "Trade.cf66312c.svg";